const LOAN_OFFICER_ROLE_PATTERN = /loan\s*officer|originator|^lo$/i;

const buildName = user => {
  if (!user) {
    return null;
  }

  const fullName =
    user.fullName ?? [user.firstName, user.lastName].filter(Boolean).join(' ').trim() ?? user.name;

  return fullName || null;
};

const resolveNmls = user =>
  user?.nmls ?? user?.nmlsId ?? user?.nmlsNumber ?? user?.licenseNumber ?? null;

export const resolveLoanOfficer = (assignedUsers = []) => {
  if (!Array.isArray(assignedUsers) || assignedUsers.length === 0) {
    return null;
  }

  const byRole = assignedUsers.find(user =>
    LOAN_OFFICER_ROLE_PATTERN.test(user?.roleName ?? user?.role ?? ''),
  );

  const target = byRole ?? assignedUsers[0];
  const name = buildName(target);

  if (!name) {
    return null;
  }

  return { name, nmls: resolveNmls(target) };
};
